import { useEffect, useState } from "react";
import "./index.css";
import { useSummerCamp } from "../../../../../APIContext/summerCampContext";
import { useNavigate } from "react-router-dom";
import ViewSummerCampModal from "./ViewSummerCampModal";

const ITEMS_PER_PAGE = 8;

const MySummerCamp = () => {
  const navigate = useNavigate();
  const { summercamplistfordashboard } = useSummerCamp();

  const [packageData, setPackageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // modal state
  const [openModal, setOpenModal] = useState(false);
  const [selectedCampId, setSelectedCampId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await summercamplistfordashboard();
      if (result) {
        setPackageData(result);
      } else {
        navigate("/login");
      }
    };
    fetchData();
  }, [navigate, summercamplistfordashboard]);

  const totalPages = Math.ceil(packageData.length / ITEMS_PER_PAGE);

  const paginatedData = packageData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );

  const handleView = (item) => {
    setSelectedCampId(item.id);
    setOpenModal(true);
  };

  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          <div className="player-header">
            <h2 className="text-clip">My Summer Camp</h2>
          </div>

          <div className="package-table">
            <div className="table-header">
              <span className="text-clip">Name</span>
              <span className="text-clip">Price</span>
              <span className="text-clip">Players</span>
              <span className="text-clip">Weeks</span>
              <span className="text-clip">Status</span>
              <span className="text-clip">Action</span>
            </div>

            {paginatedData.map((item) => (
              <div className="table-row" key={item.id}>
                <span className="text-clip" data-label="Name">
                  {item.offering_name}
                </span>
                <span className="text-clip" data-label="Price">
                  ${item.total_price}
                </span>
                <span className="text-clip" data-label="Players">
                  {item.total_players}
                </span>
                <span className="text-clip" data-label="Weeks">
                  {item.total_weeks}
                </span>
                <span data-label="Status">
                  <span
                    className="text-clip"
                    className={`status ${item.paid ? "active" : "pending"}`}
                  >
                    {item.paid ? "Paid" : "Pending"}
                  </span>
                </span>
                <span>
                  <button className="view-btn" onClick={() => handleView(item)}>
                    View
                  </button>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* MODAL */}
      <ViewSummerCampModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        id={selectedCampId}
      />
    </>
  );
};

export default MySummerCamp;
